var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-block-config" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading-state" }, [_c("a-spin")], 1)
      : _vm.blockDefinition
      ? _c(
          "div",
          { staticClass: "config-form" },
          [
            _c("div", { staticClass: "block-info-header" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.blockDefinition.icon || "extension")),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("h4", [_vm._v(_vm._s(_vm.blockDefinition.name))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.blockDefinition.description))]),
              ]),
            ]),
            _vm._v(" "),
            _c("a-divider"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-fields" },
              _vm._l(_vm.visibleParameters, function (param) {
                return _c(
                  "div",
                  { key: param.name, staticClass: "form-field" },
                  [
                    param.type === "text"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: param.description },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 2,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "number"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: param.description },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 1,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "boolean"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      model: {
                                        value: _vm.formValues[param.name],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValues,
                                            param.name,
                                            $$v
                                          )
                                        },
                                        expression: "formValues[param.name]",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(param.description || "Etkin") +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description ||
                                        "true/false or {{attribute}}",
                                      rows: 1,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "userid"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticClass: "classic-select",
                                      attrs: {
                                        placeholder:
                                          param.description || "Select user",
                                        allowClear: "",
                                      },
                                      model: {
                                        value: _vm.formValues[param.name],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValues,
                                            param.name,
                                            $$v
                                          )
                                        },
                                        expression: "formValues[param.name]",
                                      },
                                    },
                                    _vm._l(_vm.users, function (user) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: user._id,
                                          attrs: { value: user._id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(user.name) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 1,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "userid_list"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticClass: "classic-select",
                                      attrs: {
                                        mode: "multiple",
                                        placeholder:
                                          param.description || "Select users",
                                      },
                                      model: {
                                        value: _vm.formValues[param.name],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValues,
                                            param.name,
                                            $$v
                                          )
                                        },
                                        expression: "formValues[param.name]",
                                      },
                                    },
                                    _vm._l(_vm.users, function (user) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: user._id,
                                          attrs: { value: user._id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(user.name) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 1,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "json"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c("a-textarea", {
                                    attrs: {
                                      rows: 4,
                                      placeholder:
                                        param.description ||
                                        "Enter JSON object",
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 4,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : param.type === "json-structured"
                      ? [
                          _c(
                            "div",
                            { staticClass: "field-label d-flex flex-column" },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(param.label) + " "),
                                param.required
                                  ? _c("span", { staticClass: "required" }, [
                                      _vm._v("*"),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              param.description
                                ? _c("span", { staticClass: "description" }, [
                                    _vm._v(_vm._s(param.description)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Form")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c("StructuredJsonForm", {
                                    attrs: {
                                      schema: param.schema || [],
                                      "is-list": param.isList || false,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : param.type === "array"
                      ? [
                          _c("div", { staticClass: "field-label" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(param.label) +
                                "\n                        "
                            ),
                            param.required
                              ? _c("span", { staticClass: "required" }, [
                                  _vm._v("*"),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mode-switch" },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.paramModes[param.name],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.paramModes, param.name, $$v)
                                    },
                                    expression: "paramModes[param.name]",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "static" } },
                                    [_vm._v("Statik")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "dynamic" } },
                                    [_vm._v("Dinamik")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.paramModes[param.name] === "static"
                            ? _c(
                                "div",
                                [
                                  _c("a-select", {
                                    attrs: {
                                      mode: "tags",
                                      placeholder:
                                        param.description ||
                                        "Enter array items",
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      placeholder:
                                        param.description || param.label,
                                      rows: 2,
                                    },
                                    model: {
                                      value: _vm.formValues[param.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formValues,
                                          param.name,
                                          $$v
                                        )
                                      },
                                      expression: "formValues[param.name]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.outputSchema
              ? _c("div", { staticClass: "output-preview" }, [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbotv2.outputPreview") || "Output Preview"
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("pre", [
                    _vm._v(_vm._s(JSON.stringify(_vm.outputSchema, null, 2))),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        )
      : _c("div", { staticClass: "block-selector" }, [
          _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("chatbotv2.selectCustomBlock") || "Select Custom Block"
              )
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("chatbotv2.selectCustomBlockDesc") ||
                  "Choose a custom block from your imported blocks"
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "blocks-list" },
            _vm._l(_vm.importedBlocks, function (importedBlock) {
              return _c(
                "div",
                {
                  key: importedBlock.blockId,
                  staticClass: "block-option",
                  on: {
                    click: function ($event) {
                      return _vm.selectBlock(importedBlock)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$_.get(importedBlock, "block.icon", "extension")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "block-info" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          importedBlock.customName ||
                            _vm.$_.get(
                              importedBlock,
                              "block.name",
                              "Bilinmeyen Blok"
                            )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            importedBlock,
                            "block.description",
                            "Bilinmeyen Blok"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.importedBlocks.length === 0
            ? _c(
                "div",
                { staticClass: "no-blocks" },
                [
                  _c(
                    "a-empty",
                    {
                      attrs: {
                        description:
                          _vm.$t("chatbotv2.noImportedBlocks") ||
                          "No imported blocks",
                      },
                    },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.openBlockMarket },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t("chatbotv2.browseBlockMarket") ||
                                  "Browse Block Market"
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }